import { useEffect, useState, useRef } from "react";
import { Grid, Box, Typography, Link } from "@mui/material";
import { useDispatch } from "react-redux";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import globalClasses from "../../../commoncomponents/css/Global.module.css";
import { cellmaflexUrl, getRequest } from "../../../../api/AxiosAPICall";
import { setSnackbar } from "../../../commoncomponents/alert/SnackbarAction";
import CommonLayout from "../../../commoncomponents/layout/CommonLayout";
import ButtonComponent from "../../../commoncomponents/buttons/ButtonComponent";
import QrCodeLayout from "./QrCodeLayout";

const QrCode = () => {
  const [espId, setEspId] = useState<number | undefined>();
  const [estId, setEstId] = useState<number | undefined>();
  const [establishmentName, setEstablishmentName] = useState<
    string | undefined
  >();
  const [hpFullName, setHpFullName] = useState<string | undefined>();
  const [useFirstname, setUseFirstname] = useState();
  const [useLastname, setUseLastname] = useState();
  const dispatch = useDispatch();
  const [width, setWidth] = useState(window.innerWidth);
  const invRef = useRef<any>(null);
  const invRef1 = useRef<any>(null);
  const invRef2 = useRef<any>(null);
  let jwtToken: any;
  if (localStorage.getItem("token") != null) {
    jwtToken = localStorage.getItem("token");
  }
  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  const fetchQrDetails = async () => {
    const response = await getRequest("qrCode", {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    if (response.toString() === "ERROR") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Cellmaflex has encounter an issue. Please contact administrator.",
          "top",
          "center"
        )
      );
    } else if (response.toString() !== "" && typeof response !== "object") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          response.toString(),
          "top",
          "center"
        )
      );
    } else {
      setEspId(response?.data?.espId);
      setEstId(response?.data?.estId);
      setHpFullName(response?.data?.hpFullName);
      setEstablishmentName(response?.data?.establishmentName);
      setUseFirstname(response?.data?.useFirstname);
      setUseLastname(response?.data?.useLastname);
    }
  };

  useEffect(() => {
    fetchQrDetails();
  }, []);

  const printDocument = () => {
    html2canvas(invRef1.current).then((canvas) => {
      const pdf = new jsPDF("p", "mm", "a4");
      const contentWidth = canvas.width; // Width of the content
      const contentHeight = canvas.height; // Height of the content
      const pdfWidth = 210; // Width of the PDF (in mm, A4 width)
      const pdfHeight = 297; // Height of the PDF (in mm, A4 height)

      // Calculate aspect ratio of content
      const aspectRatio = contentWidth / contentHeight;

      let imageWidth: number, imageHeight: number;
      let xOffset: number, yOffset: number;

      const padding = 40; // Adjust this value to increase or decrease padding
      const maxImageWidth = pdfWidth - 2 * padding;
      const maxImageHeight = pdfHeight - 2 * padding;

      // Calculate image dimensions based on aspect ratio
      if (aspectRatio > 1) {
        // Landscape orientation
        imageWidth = Math.min(maxImageWidth, pdfWidth);
        imageHeight = imageWidth / aspectRatio;
      } else {
        // Portrait orientation
        imageHeight = Math.min(maxImageHeight, pdfHeight);
        imageWidth = imageHeight * aspectRatio;
      }

      // Calculate offsets to center the image
      xOffset = (pdfWidth - imageWidth) / 2;
      yOffset = (pdfHeight - imageHeight) / 2;

      // Add image to the first page
      pdf.addImage(
        canvas.toDataURL("image/png"),
        "PNG",
        xOffset,
        yOffset,
        imageWidth,
        imageHeight
      );

      const linkData = {
        url: `${cellmaflexUrl}?estId=${estId}`,
      };
      pdf.link(0, 0, pdfWidth, pdfHeight, { url: linkData.url });

      // Add a new page for the second QR code layout
      pdf.addPage();

      // Add image to the second page
      html2canvas(invRef2.current).then((canvas2) => {
        // Calculate aspect ratio of content for the second image
        const aspectRatio2 = canvas2.width / canvas2.height;

        // Calculate image dimensions based on aspect ratio for the second image
        let imageWidth2: number, imageHeight2: number;
        if (aspectRatio2 > 1) {
          // Landscape orientation
          imageWidth2 = Math.min(maxImageWidth, pdfWidth);
          imageHeight2 = imageWidth2 / aspectRatio2;
        } else {
          // Portrait orientation
          imageHeight2 = Math.min(maxImageHeight, pdfHeight);
          imageWidth2 = imageHeight2 * aspectRatio2;
        }

        // Calculate offsets to center the second image
        const xOffset2 = (pdfWidth - imageWidth2) / 2;
        const yOffset2 = (pdfHeight - imageHeight2) / 2;

        pdf.addImage(
          canvas2.toDataURL("image/png"),
          "PNG",
          xOffset2,
          yOffset2,
          imageWidth2,
          imageHeight2
        );

        const linkData2 = {
          url: `${cellmaflexUrl}?fromQrCodeScan=true&espId=${espId}`,
        };
        pdf.link(0, 0, pdfWidth, pdfHeight, { url: linkData2.url });

        // Save the PDF file
        pdf.save(`${useFirstname}_${useLastname}.pdf`);
      });
    });
  };

  return (
    <CommonLayout
      footer={true}
      hidePermium={false}
      showHeaderNavigation={true}
      isLogedIn={true}
    >
      <Box
        className={globalClasses.card}
        sx={{
          alignSelf: "center",
          alignItems: "center",
          padding: "5px !important",
        }}
      >
        <Grid container textAlign={"center"} ref={invRef}>
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box ref={invRef1}>
              <QrCodeLayout
                establishmentName={establishmentName}
                estId={estId}
              />
              <Box
                sx={{
                  marginTop: "1rem !important",
                  marginBottom: "1.5rem !important",
                }}
              >
                <Typography
                  sx={{
                    display: "inline",
                    padding: 0,
                    margin: 0,
                    fontSize: { xs: "16px", sm: "19px" },
                    textAlign: "center",
                  }}
                >
                  Link:{" "}
                </Typography>
                <Link
                  sx={{
                    fontSize: { xs: "16px", sm: "19px" },
                    textDecoration: "none",
                    fontWeight: 550,
                    "&:hover": { fontSize: { xs: "18px", sm: "21px" } },
                  }}
                  href={`${cellmaflexUrl}?estId=${estId}`}
                  target="_blank"
                >
                  {establishmentName?.toLocaleUpperCase()}
                </Link>
              </Box>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box ref={invRef2}>
              <QrCodeLayout hpFullName={hpFullName} espId={espId} />
              <Box sx={{ marginTop: "1rem !important" }}>
                <Typography
                  sx={{
                    display: "inline",
                    padding: 0,
                    margin: 0,
                    marginTop: "8px",
                    fontSize: { xs: "16px", sm: "19px" },
                    textAlign: "center",
                  }}
                >
                  Link:{" "}
                </Typography>
                <Link
                  sx={{
                    fontSize: { xs: "16px", sm: "19px" },
                    textDecoration: "none",
                    fontWeight: 550,
                    "&:hover": { fontSize: { xs: "18px", sm: "21px" } },
                  }}
                  href={`${cellmaflexUrl}?fromQrCodeScan=true&espId=${espId}`}
                  target="_blank"
                >
                  {hpFullName?.toLocaleUpperCase()}
                </Link>
              </Box>
            </Box>
          </Grid>
        </Grid>
        <Grid container sx={{ textAlign: "right", paddingBottom: "20px" }}>
          <Grid item xs={12}>
            <ButtonComponent
              buttonclass={globalClasses.forgotPasswordButton}
              label="Download"
              onClick={printDocument}
            />
          </Grid>
        </Grid>
      </Box>
    </CommonLayout>
  );
};

export default QrCode;

/* <Box>
<Typography sx={{display:"inline", padding: 0, margin:0, fontSize:"16px", textAlign:"center"}}>
Link: {" "}
</Typography>
<Link
  sx={{fontSize:"16px"}}
  href={
    establishmentName
      ? `${cellmaflexUrl}?estId=${estId}`
      : `${cellmaflexUrl}?fromQrCodeScan=true&espId=${espId}`
  }
>
  {establishmentName
    ? `${cellmaflexUrl}?estId=${estId}`
    : `${cellmaflexUrl}?fromQrCodeScan=true&espId=${espId}`}
</Link>
</Box> */
